import React from 'react';
import { Link } from 'react-router';
import { AvatarDropdown, AvatarMenuItem } from '@/components/Avatar';
import { Button, Image, LoadingModal, Text } from '@/components/base';
import Icon, { IconName } from '@/components/base/Icon';
import { useAuthContext } from '@/contexts/authContext';
import { ActionType } from '@/interfaces/logging';
import { InternalAdminSidebar } from '@/layouts/InternalAdminLayout/InternalAdminSidebar';
import { internalAdminRoutes } from '@/router/internalAdminRoutes';

const InternalAdminLayout = ({ children }: { children?: React.ReactNode }) => {
  const auth = useAuthContext();
  const [loading, setLoading] = React.useState(false);

  const handleLogout = async () => {
    setLoading(true);
    if (auth.logout) {
      await auth.logout();
    } else {
      alert('Cannot logout');
    }
    setLoading(false);
  };

  return (
    <div className="relative isolate h-screen w-screen overflow-x-hidden">
      <div className="fixed left-0 top-0 z-20 flex h-20 w-full">
        <div className="flex h-full w-40 flex-col justify-center bg-gray-500">
          <Image src="/assets/images/edsy-logo-white.png" alt="edsy logo" className="mt-5" />
        </div>
        <div className="flex flex-1 items-center justify-end bg-gray-300 px-10">
          <AvatarDropdown name={auth.user?.firstname ?? '?'} chevron className="min-w-0">
            {auth.user?.id && (
              <AvatarMenuItem>
                <Link
                  to={internalAdminRoutes.UserDetail.getRoute({ userId: auth.user.id })}
                  className="flex w-full items-center px-0 py-0 text-black"
                >
                  <Icon icon={IconName.User} className="mr-4" />
                  <Text variant="sm">Profile</Text>
                </Link>
              </AvatarMenuItem>
            )}
            <AvatarMenuItem>
              <Button variant="flat" className="flex w-full items-center px-0 py-0 text-black" onClick={handleLogout}>
                <Icon icon={IconName.Logout} className="mr-4" />
                <Text variant="sm">Logout</Text>
              </Button>
            </AvatarMenuItem>
          </AvatarDropdown>
        </div>
      </div>
      <div className="fixed left-0 top-20 z-10 h-[calc(100vh-80px)] w-40 overflow-y-auto bg-gray-700">
        <InternalAdminSidebar />
      </div>
      <div className="isolate z-0 ml-40 mt-20 min-h-[calc(100vh-80px)] bg-gray-50 p-10">{children}</div>
      <LoadingModal
        open={loading}
        loadingLogData={{
          action: ActionType.OnClick,
          component: 'InternalAdminLayout',
          description: 'Logging out user',
          context: { loading, userId: auth.user?.id },
        }}
      />
    </div>
  );
};

export default InternalAdminLayout;
